import React,{ Component } from 'react';
import DataTable from "../../../../components/Table/Table";
import { Link } from 'react-router-dom'

class UserTable extends Component {
    constructor(props) {
        super(props);
    }

    formatSeconds(secs) {
        if (secs < 60) {
            return <div><strong>{secs}</strong>sec</div>
        } else if (secs < 3600) {
            let minutes = Math.floor(secs / 60);
            let seconds = secs % 60;
            return <div><strong>{minutes}</strong>min <strong>{seconds}</strong>secs</div>
        } else {
            let hour = Math.floor(secs / 3600);
            secs = secs - hour * 3600;
            let minutes = Math.floor(secs / 60);
            let seconds = secs % 60;
            return <div><strong>{hour}</strong>hr <strong>{minutes}</strong>min <strong>{seconds}</strong>secs</div>
        }
    }

    render() {
        const columns = [
          {
            type: "text",
            accessor: "name",
            name: "User",
            filterable: true,
            sortable: true,
            cell: (data) => {
                const state = {
                  level: "INFO",
                  username: data.value,
                  start_date: this.props.selectOpen ? this.props.start_date : null,
                  end_date: this.props.selectOpen ? this.props.end_date : null,
                  delta: this.props.delta,
                };
                
                return (
                    <div>
                        <Link style={{ color: "black" }} to={{ pathname: "/logging", state }}>
                            {data.value}
                        </Link>
                    </div>
                );
            },
          },
          {
            type: "text",
            accessor: "kasm_length",
            name: "Total Session Usage",
            filterable: false,
            sortable: true,
            cell: (data) => <div>{this.formatSeconds(Math.round(data.value))}</div>
          },
          {
            type: "text",
            accessor: "avg_kasm_length",
            name: "Average Session Usage",
            filterable: false,
            sortable: true,
            cell: (data) => <div>{this.formatSeconds(Math.round(data.value))}</div>
          },
          {
            type: "text",
            accessor: "shortest_session",
            name: "Shortest Session",
            filterable: false,
            sortable: true,
            cell: (data) => <div>{this.formatSeconds(Math.round(data.value))}</div>
          },
          {
            type: "text",
            accessor: "longest_session",
            name: "Longest Session",
            filterable: false,
            sortable: true,
            cell: (data) => <div>{this.formatSeconds(Math.round(data.value))}</div>
          },
        ];

        return (
            <div>
                <DataTable
                    id="user"
                    data={this.props.users.data || []}
                    columns={columns}
                />
            </div>
        );
    }
}

export default UserTable;


// WEBPACK FOOTER //
// ./src/views/Reporting/ReportDashboard/ReportComponents/UserTable.js